
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[apiKey]",
      function () {
        return require("private-next-pages/[apiKey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[apiKey]"])
      });
    }
  